export const NUMBER_ONLY_REGEX = /^[-+]?[0-9]*\.?[0-9]*$/;
